module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "clahe-validator"
    }
  }, [_c('center', [_c('h2', [_vm._v("CLAHE Validator")])]), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "results-area"
  }, _vm._l((_vm.results), function(face, row_number) {
    return _c('div', {
      key: face.runtime_face_uuid,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "runtime-info-area"
    }, [_c('div', {
      staticClass: "runtime-image-area"
    }, [_c('img', {
      attrs: {
        "src": 'http://node-runner.p.owal.io:9612/faceimage/' + face.runtime_face_uuid,
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(face.camera_description) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(face.captured_at) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "pic1"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&clahe=0',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "result-prediction"
    }, [(face.regular_frontend_face_uuid && (face.regular_match_confidence > 0.9)) ? _c('div', {
      staticClass: "image-area"
    }, [_c('img', {
      attrs: {
        "src": _vm.imageUriForFrontendFaceUUID(face.regular_frontend_face_uuid)
      }
    })]) : _c('div', [(!face.regular_frontend_face_uuid) ? _c('div', [_vm._v("\n              Not a face\n            ")]) : _c('div', [_vm._v("\n               \n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "name-area"
    }, [_c('div', {
      style: ({
        background: _vm.colorForMatchConfidence(face.regular_match_confidence)
      }),
      attrs: {
        "id": "circle"
      }
    }), _vm._v(" " + _vm._s(_vm.confidenceformat(face.regular_match_confidence)) + " \n            "), _c('router-link', {
      staticClass: "potential-match-name",
      attrs: {
        "to": '/faces/' + _vm.personNameForUUID(face.regular_frontend_face_uuid)
      }
    }, [_vm._v(_vm._s(_vm.personNameForUUID(face.regular_frontend_face_uuid)))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "pic2"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&clahe=1',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "result-prediction"
    }, [(face.clahe_shape_only_frontend_face_uuid && (face.clahe_shape_only_match_confidence > 0.9)) ? _c('div', {
      staticClass: "image-area"
    }, [_c('img', {
      attrs: {
        "src": _vm.imageUriForFrontendFaceUUID(face.clahe_shape_only_frontend_face_uuid)
      }
    })]) : _c('div', [(!face.clahe_shape_only_frontend_face_uuid) ? _c('div', [_vm._v("\n              Not a face\n            ")]) : _c('div', [_vm._v("\n               \n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "name-area"
    }, [_c('div', {
      style: ({
        background: _vm.colorForMatchConfidence(face.clahe_shape_only_match_confidence)
      }),
      attrs: {
        "id": "circle"
      }
    }), _vm._v(" " + _vm._s(_vm.confidenceformat(face.clahe_shape_only_match_confidence)) + " \n            "), _c('router-link', {
      staticClass: "potential-match-name",
      attrs: {
        "to": '/faces/' + _vm.personNameForUUID(face.clahe_shape_only_frontend_face_uuid)
      }
    }, [_vm._v(_vm._s(_vm.personNameForUUID(face.clahe_shape_only_frontend_face_uuid)))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "result-prediction"
    }, [(face.clahe_full_frontend_face_uuid && (face.clahe_full_match_confidence > 0.9)) ? _c('div', {
      staticClass: "image-area"
    }, [_c('img', {
      attrs: {
        "src": _vm.imageUriForFrontendFaceUUID(face.clahe_full_frontend_face_uuid)
      }
    })]) : _c('div', [(!face.clahe_full_frontend_face_uuid) ? _c('div', [_vm._v("\n              Not a face\n            ")]) : _c('div', [_vm._v("\n               \n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "name-area"
    }, [_c('div', {
      style: ({
        background: _vm.colorForMatchConfidence(face.clahe_full_match_confidence)
      }),
      attrs: {
        "id": "circle"
      }
    }), _vm._v(" " + _vm._s(_vm.confidenceformat(face.clahe_full_match_confidence)) + " \n            "), _c('router-link', {
      staticClass: "potential-match-name",
      attrs: {
        "to": '/faces/' + _vm.personNameForUUID(face.clahe_full_frontend_face_uuid)
      }
    }, [_vm._v(_vm._s(_vm.personNameForUUID(face.clahe_full_frontend_face_uuid)))])], 1)])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fc49666","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CLAHEValidator.vue
// module id = 306
// module chunks = 1